<script>
import _ControlsBox from './_ControlsBox';

export default {
  name: 'ControlsBoxLauncher',
  components: {
    ControlsBox: _ControlsBox,
  },
};
</script>

<template lang="pug">
  ControlsBox
    span(slot="title") {{ $t('Launcher controls') }}
    div(slot="controls")
      p.descgrip.white.fw6.f7.mb3 #[em.fw7.f7.b--green.mb1.dib.ttu.green System] #[br]#[span {{ $t('Bring up this overlay when in the game launcher. Pause or switch game when playing.') }}]
      p.desctrigger.white.fw6.f7.mb3 #[em.fw7.f7.b--green.mb1.dib.ttu.green Trigger] #[br]#[span {{ $t('Press to click on games and buttons.') }}]
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.controls-box {

}
</style>
